import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

// Forgot password link url from email will look like this: /forgot-password/totp?token=<token>&user_id=<user_id>
export const getForgotPasswordValidateTotpPath = () => urlHelper(`/forgot-password/totp`);
